/**
 * Stealth Page Component
 *
 * A completely blank white page shown when stealth mode is enabled.
 * No text, no branding, nothing - just a blank page. This is the highest
 * priority mode and overrules pre-launch and normal modes.
 */
export function StealthPage() {
	return <div className="min-h-screen bg-white" />
}
